import { AppModule } from '@app/types';
import StreamerBoxIcon from './components/StreamerBoxIcon';

export const StreamerBoxModule: AppModule = {
  id: 'streamBox',
  icon: <StreamerBoxIcon />,
  title: 'StreamBox',
  basePath: 'stream-box',
};
